import { submitOnEnter } from '@euler/app/flows/ai-suite/components/submitOnEnter';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ArrowUp } from 'lucide-react-native';
import { memo, useMemo, useState } from 'react';
import { Pressable, StyleSheet, TextInput, View } from 'react-native';

/** Where the trainee describes a situation they want to practise. */
export const CoachingPrompt = memo(
  ({ onSubmit }: { onSubmit: (text: string) => void }) => {
    const styles = useStyles();
    const { rpx } = useResponsiveContext();
    const [text, setText] = useState('');
    const ready = !!text.trim();
    const submit = () => {
      if (!ready) return;
      onSubmit(text.trim());
      setText('');
    };
    return (
      <View style={styles.card}>
        <TextInput
          accessibilityLabel="说说你遇到的情况"
          value={text}
          onChangeText={setText}
          onKeyPress={submitOnEnter(submit)}
          placeholder="说说你遇到的情况，比如“客户嫌刹车片贵，说网上便宜三百”…"
          placeholderTextColor={aiColors.mutedForeground}
          multiline
          style={styles.input}
        />
        <View style={styles.actions}>
          <Pressable
            onPress={submit}
            disabled={!ready}
            accessibilityRole="button"
            accessibilityLabel="发送"
            style={[styles.send, !ready && styles.sendDisabled]}
          >
            <ArrowUp size={rpx(18)} color={aiColors.primaryForeground} />
          </Pressable>
        </View>
      </View>
    );
  },
);

function useStyles() {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () =>
      StyleSheet.create({
        card: {
          borderRadius: rpx(18),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: aiColors.card,
        },
        input: {
          minHeight: rpx(84),
          paddingHorizontal: rpx(16),
          paddingTop: rpx(12),
          fontSize: rpx(15),
          lineHeight: rpx(22),
          color: aiColors.foreground,
          textAlignVertical: 'top',
        },
        actions: {
          flexDirection: 'row',
          justifyContent: 'flex-end',
          padding: rpx(8),
        },
        send: {
          width: rpx(36),
          height: rpx(36),
          borderRadius: rpx(12),
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: aiColors.primary,
        },
        sendDisabled: { opacity: 0.5 },
      }),
    [rpx],
  );
}
